import { Button, Dialog, Grid, makeStyles } from '@material-ui/core'
import { FC, useRef } from 'react'
import { Form as FinalForm, FormRenderProps } from 'react-final-form'
import MyAccordion from '../../../control/accordion/accordion'
import useTranslate from '../../../i18n/useTranslate'
import Officer from './officer'
import UploadLogo from './UploadLogo'
import { CertificateFormProps } from '../../../pages/SettingCertificate'

interface FormProps {
    onSubmit: (value: CertificateFormProps) => void
    initialValues?: CertificateFormProps
}

const Form: FC<FormProps> = ({ onSubmit, initialValues }) => {
    const translate = useTranslate()
    const classes = useStyles()
    const formPropsRef = useRef<any>()

    const validateForm = (values: CertificateFormProps) => {
        const errors: any = {}
        if (!values.imgUpload_th) {
            errors.imgUpload_th = `${translate.get('UM.UPLOAD.REQUIRED')}`
        }

        if (!values.imgUpload_en) {
            errors.imgUpload_en = `${translate.get('UM.UPLOAD.REQUIRED')}`
        }

        return errors
    }

    return (
        <>
            <FinalForm onSubmit={onSubmit} initialValues={initialValues} validate={validateForm}>
                {({ handleSubmit, form }) => {
                    return (
                        <Grid container className={classes.root}>
                            <Grid item xs={12}>
                                <MyAccordion title={translate.get('UM.SETTINGCERTIFICATE.HEADER_1')}>
                                    <Officer />
                                </MyAccordion>
                            </Grid>

                            <Grid item xs={12} style={{ marginTop: '20px' }}>
                                <MyAccordion title={translate.get('UM.UPLOAD.HEADER')}>
                                    <UploadLogo form={form} initialValues={initialValues} />
                                </MyAccordion>
                            </Grid>
                            <Grid item xs={12} className={classes.buttonSection}>
                                <Grid container justify="flex-end">
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                            className={classes.btnSubmit}
                                        >
                                            {translate.get('BUTTON.SAVE')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )
                }}
            </FinalForm>
        </>
    )
}

export default Form
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    buttonSection: {
        marginTop: '10px',
    },
    btnSubmit: {
        float: 'right',
        minWidth: '0px',
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
    },
}))
